<div class="upload-modal">
  <div class="upload-modal__header">
    <h2>{{ 'inventory.uploadItemsList' | translate }}</h2>
    <button class="upload-modal__close" (click)="close()">
      <app-icon [icon]="iconName.CLOSE" />
    </button>
  </div>
  <div class="upload-modal__content">
    <app-upload-inventory-items />
  </div>
</div>
